// localStorage keys of the myGAP Farm Record notes (see MyGAPReport.js, WI-22a).
// Kept in this tiny module so AuthContext can clear the per-user cache on
// sign-out without importing the report component.
//
//   cache    `${NOTES_CACHE_LS_PREFIX}${authUid}`    notes this user saw (DB rows + own edits)
//   pending  `${NOTES_PENDING_LS_PREFIX}${authUid}`  this user's edits not yet confirmed saved
//   legacy   NOTES_LEGACY_LS                        pre-DB store (one per browser), read until
//                                                   the farm's one-time upload is done
export const NOTES_CACHE_LS_PREFIX = 'mygap_notes_v2:';
export const NOTES_PENDING_LS_PREFIX = 'mygap_notes_pending:';
export const NOTES_LEGACY_LS = 'mygap_notes';
export const NOTES_MIGRATED_LS_PREFIX = 'mygap_notes_migrated_';   // + farm id
// Unscoped keys written by the first (never deployed) WI-22a build; removed on sight.
export const NOTES_OLD_UNSCOPED_LS = ['mygap_notes_v2', 'mygap_notes_unsynced'];

// Sign-out: drop every user's cached copy of other people's notes (4-8 holds IC
// numbers / health notes). Each user's own unsent edits stay under their own
// key, so they are never sent under the next user's session.
export function clearMyGapNotesCache() {
  try {
    const drop = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && (k.startsWith(NOTES_CACHE_LS_PREFIX) || NOTES_OLD_UNSCOPED_LS.includes(k))) drop.push(k);
    }
    drop.forEach(k => localStorage.removeItem(k));
  } catch { /* storage unavailable (private mode) */ }
}
